// extracted by mini-css-extract-plugin
module.exports = {"mainHeading":"scroller-module--mainHeading--zk8km"};